<template>
    <div class="midea-pay-dialog">
        <el-dialog
            title="注册美的付"
            :visible.sync="visible"
            style="min-width: 1200px;"
            :before-close="handleClose">
            <el-form ref="form" class="form" :model="form" :rules="rules" label-width="110px" size="mini" style="font-size: 14px;">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                    <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="美的付登录名" prop="mideaPayLoginName">
                    <el-input v-model="form.mideaPayLoginName" placeholder="请输入美的付登录名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="身份证开始日期" prop="idCardStartDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.idCardStartDate" type="date"></el-date-picker>
                </el-form-item>
                <el-form-item label="身份证到期日期" prop="idCardEndDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.idCardEndDate" type="date"></el-date-picker>
                </el-form-item>
                <el-form-item label="当前住址"  class="region-select">
                    <el-form-item prop="provinceCode">
                        <m-select class="select-item" placeholder="省份" :flag="provinceOptions" :optionArr="provinceOptions" :value="form.provinceCode" :filterable="true"
                            @getSelectLabel="setValue($event, 'provinceName')" @input="setValue($event, 'provinceCode')"></m-select>
                    </el-form-item>
                    <el-form-item prop="cityCode">
                        <m-select class="select-item" placeholder="城市" :flag="cityOptions" :optionArr="cityOptions" :value="form.cityCode" :filterable="true"
                            @getSelectLabel="setValue($event, 'cityName')" @input="setValue($event, 'cityCode')"></m-select>
                    </el-form-item>
                    <el-form-item prop="districtCode">
                        <m-select class="select-item" placeholder="区县" :flag="districtOptions" :optionArr="districtOptions" :value="form.districtCode" :filterable="true"
                            @getSelectLabel="setValue($event, 'districtName')" @input="setValue($event, 'districtCode')"></m-select>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import mSelect from '../../../../../../components/Select.vue';
import { getProvinces, getCitys, getDistricts } from '../../../../../../utils/getArea';
import { getRegisterPageInitData, mideaPayRegister } from '../../../../../../api/finance.js';
import { identityVerify, phoneVerify } from '../../../../../../constant/formRegular.js';

const CHINA_CODE = '100000';
export default {
    name: 'midea-pay-dialog',
    components: { mSelect },
    props: {
        supplierCode: {
            type: String,
            default: () => null
        },
        visible: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            form: {
                name: null,
                idCard: null,
                mideaPayLoginName: null,
                phone: null,
                idCardStartDate: null,
                idCardEndDate: null,
                provinceCode: null,
                cityCode: null,
                districtCode: null,
                provinceName: null,
                cityName: null,
                districtName: null,
                address: null
            },
            rules: {
                name: [
                    { required: true, message: '姓名不能为空', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z\u4e00-\u9fa5 ]{1,64}$/, message: '请输入64位以内的汉字、数字或字母', trigger: ['blur', 'change'] }
                ],
                idCard: [
                    { required: true, message: '身份证号不能为空', trigger: ['blur', 'change'] },
                    { pattern: identityVerify, message: '身份证号格式有误', trigger: ['blur', 'change'] }
                ],
                mideaPayLoginName: [
                    { required: true, message: '美的付登录名不能为空', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{1,32}$/, message: '请输入32位以内的数字或字母', trigger: ['blur', 'change'] }
                ],
                phone: [
                    { required: true, message: '手机号不能为空', trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '手机号格式有误', trigger: ['blur', 'change'] }
                ],
                idCardStartDate: [{ required: true, message: '身份证开始日期不能为空', trigger: ['blur', 'change'] }],
                idCardEndDate: [
                    { required: true, message: '身份证到期日期不能为空', trigger: ['blur', 'change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (!value && !this.form.idCardStartDate) { callback(); }
                            const endDate = new Date(value).getTime(); // 到期日期
                            const startDate = new Date(this.form.idCardStartDate).getTime();// 开始日期
                            if (endDate - startDate <= 0) {
                                callback(new Error('身份证到期日期要大于开始日期'));
                            } else { callback(); }
                        },
                        message: '身份证到期日期要大于开始日期',
                        trigger: ['blur', 'change']
                    }
                ],
                provinceCode: [{ required: true, message: '省份不能为空', trigger: ['blur', 'change'] }],
                cityCode: [{ required: true, message: '城市不能为空', trigger: ['blur', 'change'] }],
                districtCode: [{ required: true, message: '区县不能为空', trigger: ['blur', 'change'] }],
                address: [
                    { required: true, message: '详细地址不能为空', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z\u4e00-\u9fa5 ]{1,128}$/, message: '请输入128位以内的汉字、数字或字母', trigger: ['blur', 'change'] }
                ]
            },
            provinceOptions: [],
            cityOptions: [],
            districtOptions: [],
            loading: false
        };
    },
    methods: {
        handleClose() {
            this.$emit('close');
            this.$refs['form'].resetFields();
        },
        handleConfirm () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    mideaPayRegister({ supplierCode: this.supplierCode, ...this.form }).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('注册成功');
                            this.$emit('close');
                            this.$emit('refresh');
                        }
                    }).finally(() => { this.loading = false; });
                }
            });
        },
        setValue(data, key) {
            this.$set(this.form, key, data);
            if (key === 'provinceCode') {
                this.$set(this.form, 'cityCode', null);
                this.$set(this.form, 'cityName', null);
                this.$set(this.form, 'districtCode', null);
                this.$set(this.form, 'districtName', null);
                this.setRegionOptions();
            }
            if (key === 'cityCode') {
                this.$set(this.form, 'districtCode', null);
                this.$set(this.form, 'districtName', null);
                this.setRegionOptions();
            }
        },
        setRegionOptions() {
            if (this.provinceOptions.length === 0) {
                getProvinces(CHINA_CODE).then(res => {
                    this.provinceOptions = res;
                });
            }
            if (this.form.provinceCode) {
                getCitys(this.form.provinceCode).then(res => {
                    this.cityOptions = res;
                });
            }
            if (this.form.cityCode) {
                getDistricts(this.form.cityCode).then(res => {
                    this.districtOptions = res;
                });
            }
        },
        initData(data) {
            for (const key in this.form) {
                if (key) {
                    this.form[key] = data[key];
                }
            }
            this.setRegionOptions();
        }
    },
    mounted() {
        this.setRegionOptions();
    },
    watch: {
        visible(val) {
            if (val) {
                getRegisterPageInitData(this.supplierCode).then(res => {
                    if (res && res.code === '0') {
                        this.initData(res.data);
                    }
                });
            }
        }
    }
};
</script>
<style lang="less">
.midea-pay-dialog {
    .el-form > .el-form-item > .el-form-item__content {
        width: 65%;
    }
    .region-select {
        margin-bottom: 0;
        .el-form-item__content {
            display: flex;
            .el-form-item {
                margin-right: 5px;
            }
        }
        .el-form-item__label:before {
            content: '*';
            color: #F96C5F;
            margin-right: 4px;
        }
    }
}
</style>
